import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_URL;

var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";

var configHeader = {};

if (isUserLogged) {
      configHeader =
      {
            'Accept': 'application/json, text/plain,  multipart/form-data, */*',
            "Content-Type": "application/json,  multipart/form-data",
            "Authorization" : `Bearer ${isUserLogged.token}`,
      }
}
else {
      configHeader =
      {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
      }
}

// defining default config using axios
export const configAxios = axios.create({
      baseURL: BASE_URL,
      headers: configHeader
});
